import { render, staticRenderFns } from "./details-datasources.vue?vue&type=template&id=eafaf974&"
import script from "./details-datasources.vue?vue&type=script&lang=js&"
export * from "./details-datasources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports